import styled from 'styled-components';

const ItalicComponent = styled.em``;
export const ItalicEditable = ItalicComponent;
export const ItalicRenderer = ItalicComponent;
